import { useState } from "react";
import { Switch, Route } from "react-router-dom";
import TrialAuthProvider from "../Context/TrialAuthContext";
import { MixernTrialContent } from "./MixernTrial";
import FixedCostsTrial from "./FixedCostsTrial";
import HeaderTrial from "../Component/Header/HeaderTrial";
import HeaderMobileTrial from "../Component/Header/HeaderMobileTrial";
import HelpModalTrial from "../Component/HelpModal/HelpModalTrial";
import useWindowSize from "../Component/use-window-size";
import { useSelector } from "react-redux";

export default function TrialRouter() {
  const [helpModalActive, setHelpModalActive] = useState(false);
  const [helpModalContent, setHelpModalContent] = useState("1.0");
  const size = useWindowSize();
  const sizeForMobile = useSelector((state) => state.sizeForMobile.size);

  return (
    <TrialAuthProvider>
      {helpModalActive && (
        <HelpModalTrial
          setHelpModalActive={setHelpModalActive}
          helpModalContent={helpModalContent}
          setHelpModalContent={setHelpModalContent}
        />
      )}

      {size.width < sizeForMobile ? (
        <HeaderMobileTrial
          setHelpModalActive={setHelpModalActive}
          setHelpModalContent={setHelpModalContent}
        />
      ) : (
        <HeaderTrial
          setHelpModalActive={setHelpModalActive}
          setHelpModalContent={setHelpModalContent}
        />
      )}

      <Switch>
        <Route exact path="/trial" component={MixernTrialContent} />
        <Route path="/trial/fastaKostnader" component={FixedCostsTrial} />
      </Switch>
    </TrialAuthProvider>
  );
}
